/* The Art of Gifting · page scripts. Loaded with defer, only on this template. */
(function () {
  if (window.__aogInit) return;
  window.__aogInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.aog-reveal:not(.is-visible)');
    // anything already on screen stays visible, so nothing flashes away and back
    items.forEach(function (i) { if (i.getBoundingClientRect().top < window.innerHeight) i.classList.add('is-visible'); });
    document.documentElement.classList.add('aog-js');
    items = document.querySelectorAll('.aog-reveal:not(.is-visible)');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ---------- Smooth anchor scroll ---------- */
  function initAnchors() {
    document.querySelectorAll('.aog a[href^="#"]:not([data-aog-bound]):not([data-aog-shop-filter])').forEach(function (a) {
      a.setAttribute('data-aog-bound', '');
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('href').slice(1), target = id && document.getElementById(id);
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'aog-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- Add to cart (Dawn cart drawer or notification) ---------- */
  function cartTarget() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function refreshBubble() {
    fetch(window.location.pathname + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (html) {
      var bubble = document.getElementById('cart-icon-bubble');
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  function addToCart(items, opts) {
    opts = opts || {};
    var target = cartTarget(), body = { items: items };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var btn = opts.button, statusEl = opts.status;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (statusEl) statusEl.textContent = '';
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, data: j }; }); })
      .then(function (res) {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        if (!res.ok || res.data.status) {
          var msg = res.status === 422 ? 'This piece is one of a kind and already in your cart.' : ((res.data && (res.data.description || res.data.message)) || 'This piece could not be added.');
          if (statusEl) statusEl.textContent = msg; else toast(msg);
          return false;
        }
        var data = res.data, rendered = false;
        if (target && typeof target.renderContents === 'function' && data.sections) {
          try {
            if (target.classList && target.classList.contains('is-empty')) target.classList.remove('is-empty');
            target.renderContents(Object.assign({}, data.items ? data.items[0] : data, { sections: data.sections }));
            rendered = true;
          } catch (e) { rendered = false; }
        }
        if (!rendered) { refreshBubble(); toast(items.length > 1 ? 'Your set is in the cart' : 'Added to your cart'); }
        if (statusEl) statusEl.innerHTML = 'Added. <a href="' + cartUrl + '">View cart</a>';
        return true;
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        var m = 'Something went wrong. Please try again.';
        if (statusEl) statusEl.textContent = m; else toast(m);
        return false;
      });
  }
  window.AOG = { addToCart: addToCart };

  function initCards() {
    document.addEventListener('submit', function (ev) {
      var form = ev.target.closest('[data-aog-add]');
      if (!form) return;
      ev.preventDefault();
      var input = form.querySelector('[name="id"]');
      if (!input || !input.value) return;
      var btn = form.querySelector('[type="submit"]');
      addToCart([{ id: Number(input.value), quantity: 1 }], { button: btn }).then(function (ok) {
        if (!ok || !btn) return;
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
      });
    });

    // ready made sets
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-aog-set-add]');
      if (!btn) return;
      var ids = (btn.getAttribute('data-ids') || '').split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
      if (ids.length) addToCart(ids, { button: btn, status: btn.parentElement.querySelector('[data-aog-status]') });
    });
  }

  /* ---------- Carousel: arrows + filters ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-aog-carousel]:not([data-aog-ready])').forEach(function (root) {
      root.setAttribute('data-aog-ready', '');
      var track = root.querySelector('.aog-track'), prev = root.querySelector('[data-aog-prev]'), next = root.querySelector('[data-aog-next]');
      var count = root.querySelector('[data-aog-count]'), onlyAvail = root.querySelector('[data-aog-available]'), chips = root.querySelectorAll('[data-aog-filter]');
      var current = 'all', seen = {};
      track.querySelectorAll('li[data-product-id]').forEach(function (li) {
        var id = li.getAttribute('data-product-id');
        if (seen[id]) {
          var merged = (seen[id].getAttribute('data-group') + ' ' + li.getAttribute('data-group')).split(' ');
          seen[id].setAttribute('data-group', merged.filter(function (g, i) { return g && merged.indexOf(g) === i; }).join(' '));
          li.remove();
        } else { seen[id] = li; }
      });
      var paged = root.hasAttribute('data-aog-paged');
      var step = function () {
        var item = track.querySelector('li:not([hidden])');
        if (!item) return track.clientWidth;
        var cs = getComputedStyle(track), gap = parseFloat(cs.columnGap || 0);
        var col = item.getBoundingClientRect().width + gap;
        if (!paged) return col;
        var inner = track.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
        return Math.max(1, Math.floor((inner + gap + 2) / col)) * col;   // one full page of columns
      };
      var updateArrows = function () { if (!prev || !next) return; prev.disabled = track.scrollLeft <= 4; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; };
      var apply = function () {
        var visible = 0;
        track.querySelectorAll('li[data-group]').forEach(function (li) {
          var show = (current === 'all' || li.getAttribute('data-group').split(' ').indexOf(current) > -1) && (!onlyAvail || !onlyAvail.checked || li.hasAttribute('data-available'));
          li.hidden = !show; if (show) visible++;
        });
        if (count) count.textContent = visible + (visible === 1 ? ' frame' : ' frames');
        track.scrollTo({ left: 0 }); updateArrows();
      };
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          current = chip.getAttribute('data-aog-filter');
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          apply();
        });
      });
      if (onlyAvail) onlyAvail.addEventListener('change', apply);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); }, { passive: true });
      apply();
    });
  }

  /* ---------- Create your own set ---------- */
  // formats cents with the shop's own money format, e.g. "€{{amount_with_comma_separator}}"
  function money(cents, format) {
    format = format || '€{{amount_with_comma_separator}}';
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (parts[1] ? ds + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function initBuilders() {
    document.querySelectorAll('[data-aog-builder]:not([data-aog-ready])').forEach(function (root) {
      root.setAttribute('data-aog-ready', '');
      var dataEl = root.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var products = JSON.parse(dataEl.textContent);
      var max = Number(root.getAttribute('data-max')) || 3, min = Number(root.getAttribute('data-min')) || 2;
      var slots = Array.prototype.slice.call(root.querySelectorAll('.aog-slot')), picks = root.querySelectorAll('.aog-pick');
      var totalEl = root.querySelector('[data-aog-total]'), countEl = root.querySelector('[data-aog-count]'), hint = root.querySelector('[data-aog-hint]');
      var addBtn = root.querySelector('[data-aog-builder-add]'), statusEl = root.querySelector('[data-aog-status]');
      var chosen = slots.map(function () { return null; });   // one entry per spot on the wall
      var byId = {}; products.forEach(function (p) { byId[p.v] = p; });
      function filled() { return chosen.filter(Boolean); }

      function render() {
        slots.forEach(function (slot, i) {
          var p = byId[chosen[i]];
          slot.classList.toggle('is-filled', !!p);
          var img = slot.querySelector('img');
          if (p) {
            if (!img) { img = document.createElement('img'); img.alt = ''; img.draggable = false; slot.insertBefore(img, slot.firstChild); }
            img.src = p.img; img.alt = p.t;
            slot.setAttribute('aria-label', 'Remove ' + p.t);
            slot.querySelector('.aog-slot__label').hidden = true;
          } else {
            if (img) img.remove();
            slot.setAttribute('aria-label', 'Empty spot ' + (i + 1));
            slot.querySelector('.aog-slot__label').hidden = false;
          }
        });
        var list = filled();
        picks.forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-v')) > -1 ? 'true' : 'false'); });
        var total = list.reduce(function (sum, v) { return sum + byId[v].p; }, 0);
        totalEl.textContent = money(total, root.getAttribute('data-money'));
        countEl.textContent = list.length + (list.length === 1 ? ' frame' : ' frames');
        addBtn.disabled = list.length < min;
        if (hint) hint.textContent = list.length === 0 ? 'Drag a frame onto the wall or tap it.' : (list.length < min ? 'Add ' + (min - list.length) + ' more to complete your set.' : (list.length < max ? 'Your set is ready. Add one more if you like.' : 'Your set is complete.'));
      }

      function place(v, index) {
        var from = chosen.indexOf(v);
        if (index == null) {                      // tap: first empty spot, or replace the last one
          if (from > -1) { chosen[from] = null; render(); return; }
          index = chosen.indexOf(null);
          if (index < 0) index = chosen.length - 1;
        }
        if (from > -1 && from !== index) chosen[from] = chosen[index];   // swap when moving between spots
        chosen[index] = v;
        render();
        var slot = slots[index];
        if (slot && !reduceMotion) { slot.classList.remove('is-dropped'); void slot.offsetWidth; slot.classList.add('is-dropped'); }
      }

      /* ----- drag and drop (mouse, pen and touch) ----- */
      var drag = null;
      function slotAt(x, y) {
        for (var i = 0; i < slots.length; i++) {
          var r = slots[i].getBoundingClientRect(), pad = 14;
          if (x >= r.left - pad && x <= r.right + pad && y >= r.top - pad && y <= r.bottom + pad) return i;
        }
        return -1;
      }
      function startDrag(v, fromSlot, x, y, sourceImg) {
        var ghost = document.createElement('div');
        ghost.className = 'aog-ghost';
        var size = slots[0] ? slots[0].getBoundingClientRect().width : 90;
        ghost.style.width = ghost.style.height = Math.max(70, Math.min(size, 160)) + 'px';
        var img = document.createElement('img'); img.src = byId[v].img; img.alt = ''; ghost.appendChild(img);
        document.body.appendChild(ghost);
        root.classList.add('is-dragging');
        drag.active = true; drag.v = v; drag.fromSlot = fromSlot; drag.ghost = ghost;
        moveDrag(x, y);
      }
      function moveDrag(x, y) {
        if (!drag || !drag.ghost) return;
        var w = drag.ghost.offsetWidth;
        drag.ghost.style.transform = 'translate(' + (x - w / 2) + 'px,' + (y - w / 2) + 'px)';
        var over = slotAt(x, y);
        slots.forEach(function (s, i) { s.classList.toggle('is-over', i === over); });
      }
      function endDrag(x, y) {
        if (!drag) return;
        var d = drag; drag = null;
        if (d.timer) clearTimeout(d.timer);
        if (!d.active) return;
        var over = slotAt(x, y);
        if (over > -1) place(d.v, over);
        else if (d.fromSlot > -1) { chosen[d.fromSlot] = null; render(); }   // dragged off the wall: remove
        if (d.ghost) d.ghost.remove();
        root.classList.remove('is-dragging');
        slots.forEach(function (s) { s.classList.remove('is-over'); });
        d.el.dataset.aogDragged = '1';
        setTimeout(function () { delete d.el.dataset.aogDragged; }, 50);
      }
      function bindDrag(el, getV, fromSlot) {
        el.addEventListener('pointerdown', function (ev) {
          if (ev.button !== 0 && ev.pointerType === 'mouse') return;
          var v = getV(); if (!v) return;
          drag = { el: el, x: ev.clientX, y: ev.clientY, active: false, touch: ev.pointerType !== 'mouse', v: v, fromSlot: fromSlot };
          if (drag.touch) {
            // on touch, hold briefly so normal scrolling still works
            drag.timer = setTimeout(function () { if (drag && !drag.active) { startDrag(v, fromSlot, drag.x, drag.y); if (navigator.vibrate) navigator.vibrate(10); } }, 220);
          }
        });
      }
      picks.forEach(function (b) { bindDrag(b, function () { return b.getAttribute('data-v'); }, -1); });
      slots.forEach(function (s, i) { bindDrag(s, function () { return chosen[i]; }, i); });
      document.addEventListener('pointermove', function (ev) {
        if (!drag) return;
        if (!drag.active) {
          var dist = Math.hypot(ev.clientX - drag.x, ev.clientY - drag.y);
          if (drag.touch) { if (dist > 10) { clearTimeout(drag.timer); drag = null; } return; }   // finger moved first: it is a scroll
          if (dist > 6) startDrag(drag.v, drag.fromSlot, ev.clientX, ev.clientY);
          return;
        }
        moveDrag(ev.clientX, ev.clientY);
      });
      document.addEventListener('pointerup', function (ev) { endDrag(ev.clientX, ev.clientY); });
      document.addEventListener('pointercancel', function () { if (drag) { if (drag.ghost) drag.ghost.remove(); root.classList.remove('is-dragging'); drag = null; } });
      // while a frame is held on touch, stop the page from scrolling
      document.addEventListener('touchmove', function (ev) { if (drag && drag.active) ev.preventDefault(); }, { passive: false });
      root.addEventListener('dragstart', function (ev) { ev.preventDefault(); });

      /* ----- tap / click ----- */
      picks.forEach(function (b) {
        b.addEventListener('click', function () { if (b.dataset.aogDragged) return; place(b.getAttribute('data-v'), null); });
      });
      slots.forEach(function (slot, i) {
        slot.addEventListener('click', function () { if (slot.dataset.aogDragged) return; if (chosen[i]) { chosen[i] = null; render(); } });
      });
      addBtn.addEventListener('click', function () {
        var list = filled();
        if (list.length < min) return;
        addToCart(list.map(function (v) { return { id: Number(v), quantity: 1 }; }), { button: addBtn, status: statusEl });
      });
      render();
    });
  }

  /* ---------- Buttons that jump to the shop row with a filter ---------- */
  function initShopFilterLinks() {
    document.querySelectorAll('[data-aog-shop-filter]:not([data-aog-bound-f])').forEach(function (a) {
      a.setAttribute('data-aog-bound-f', '');
      a.addEventListener('click', function (ev) {
        var shop = document.getElementById('aog-shop');
        if (!shop) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var chip = shop.querySelector('[data-aog-filter="' + a.getAttribute('data-aog-shop-filter') + '"]');
        if (chip) chip.click();
        shop.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Video: play only when visible ---------- */
  function initVideos() {
    var vids = document.querySelectorAll('.aog [data-aog-video] video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && !reduceMotion) e.target.play().catch(function () {}); else e.target.pause(); });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() { initReveal(); initShopFilterLinks(); initAnchors(); initCards(); initCarousels(); initBuilders(); initVideos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCarousels(); initBuilders(); initVideos(); initShopFilterLinks(); initAnchors(); });
})();
